module.exports = __webpack_public_path__ + "img/iconWhatsapp.c29dadcc.svg";